import { Checkbox, Col, Form, Input, InputNumber, Row } from 'antd'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import ProductSelection from '../../../../elements/ProductSelection'
import UOM from '../../../../elements/Select/UOM'
import Taxes from '../../../../elements/Taxes'
import _, { get, isEmpty } from 'lodash'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  TwoPartThreeColFormItemLayout,
} from '../../../../modules/FormItems'
import { numVal, strVal } from '../../../../modules/Utils'
import React, { useEffect, useState } from 'react'

import MaterialDetails from '../../../../elements/MaterialDetails'
import ShippingDetails from '../../../../elements/ShippingDetails'

const { TextArea } = Input

function VendorQuotesLinesForm(props) {
  const { line, vendorQuote } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields, getFieldsValue } = props.form

  //const [enquiryLine, setEnquiryLine] = useState({})

  const [category, setCategory] = useState({})
  console.log({ category })
  const isSalesRFQ = _.get(vendorQuote, 'rfq.type') === 'Sales'
  const isMaterials = _.get(category, 'name') !== 'Delivery'
  console.log(111, isMaterials)
  const enquiryId = _.get(vendorQuote, 'enquiry._id') || ''
  const [EnquiryLinesSelect] = useFetchSelectUrl(
    {
      name: 'enquiriesLines',
      url: `/enquiries/lines/${enquiryId.replace('activities/', '')}`,
      cache: true,
      forceFetch: true,
    },
    [enquiryId],
    isEmpty(enquiryId),
    undefined,
    (c) => ({
      ...c,
      display: `${strVal(c, 'name')} - ${strVal(c, 'description')}`,
    })
  )

  useEffect(() => {
    // console.log(enquiryLine)
  }, [getFieldValue('enquiryLines._id')])

  const disabledValue = getFieldValue('noVNo') === true ? 'disabled' : false

  return (
    <Form>
      {enquiryId && (
        <Row>
          <Col span={12}>
            <Form.Item {...fullWidthFormItemLayout} label="Enquiry Lines">
              {getFieldDecorator('enquiryLines._id', {
                initialValue: strVal(line, 'enquiryLines._id'),
              })(
                <EnquiryLinesSelect
                  keyAtr={'_id'}
                  valueAtr={'display'}
                  placeholder={'Enquiry Lines'}
                  //   setSelected={setEnquiryLine}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'no Vendor Part No'}>
              {getFieldDecorator('noVNo', {
                initialValue: get(line, 'noVNo') || false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
        </Row>
      )}
      <FormSectionTitle title={'VENDOR QUOTE LINE'} />

      <Row>
        <Col span={4}>
          <Form.Item {...defaultFormItemLayout} label="Item:">
            {getFieldDecorator('no', {
              initialValue: strVal(line, 'no'),
              rules: rules.select,
            })(<Input placeholder={'Line No'} />)}
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item {...defaultFormItemLayout} label="Vendor Part No:">
            {getFieldDecorator('vendorNo', {
              initialValue: getFieldValue('noVNo') === true ? 'NVPN' : strVal(line, 'vendorNo'),
              rules: isMaterials ? rules.input : false,
            })(<Input placeholder={'Vendor Part No'} disabled={disabledValue} />)}
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item {...defaultFormItemLayout} label="Item Name">
            {getFieldDecorator('name', {
              initialValue: strVal(line, 'name'),
              rules: rules.select,
            })(<Input placeholder={'Item Name'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item {...TwoPartThreeColFormItemLayout} label="Description">
            {getFieldDecorator('description', {
              initialValue: strVal(line, 'description'),
              rules: rules.select,
            })(<TextArea placeholder={'Description'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label="Unit (Qty)">
            {getFieldDecorator('unit', {
              initialValue: strVal(line, 'unit'),
              rules: rules.input,
            })(<InputNumber placeholder={'Unit (Qty)'} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label="UOM">
            {getFieldDecorator('uom.code', {
              initialValue: strVal(line, 'uom.code'),
              rules: rules.select,
            })(<UOM />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label="Unit Price">
            {getFieldDecorator('rate', {
              initialValue: numVal(line, 'rate'),
              rules: rules.select,
            })(<InputNumber placeholder={'Unit Price (Rate)'} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Taxes
          doc={line}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'vendorQuoteLine',
            price: 0,
            hideRate: true,
          }}
        />
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label="Delivery Days">
            {getFieldDecorator('delivery.no', {
              initialValue: get(line, 'delivery.no') || numVal(vendorQuote, 'delivery.no'),
              rules: rules.select,
            })(<InputNumber placeholder={'Delivery Days'} />)}
          </Form.Item>
        </Col>
      </Row>
      {isMaterials && (
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Warranty">
              {getFieldDecorator('vendorWarranty', {
                initialValue: strVal(line, 'vendorWarranty') || null,
              })(<TextArea placeholder={'Warranty'} />)}
            </Form.Item>
          </Col>
        </Row>
      )}
      <ProductSelection
        doc={line}
        {...{
          getFieldDecorator,
          getFieldsValue,
          getFieldValue,
          setFieldsValue,
          resetFields,
          company: get(vendorQuote, 'company._id'),
          setCategory,
        }}
      />
      {isMaterials && (
        <>
          <MaterialDetails
            line={line}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'vendorQuote',
            }}
          />

          <ShippingDetails
            line={line}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'vendorQuote',
            }}
          />
        </>
      )}
    </Form>
  )
}

VendorQuotesLinesForm.propTypes = {}
VendorQuotesLinesForm.defaultProps = {}

export default Form.create()(VendorQuotesLinesForm)
